<template>
  <div class="booking-list">
    <div class="day-info sticky top55" v-if="info"><div>{{day.name}}</div><div>{{day.display}}</div></div>
    <div class="booking-wrapper" @click="handleClick($event)">
      <Booking class="booking" v-for="booking in bookings"
        :key="booking.id"
        :data="booking">
      </Booking>
    </div>
  </div>
</template>

<script>

import Booking from '@/components/Booking';

const HOURS = [
  '8:00', '9:00', '10:00', '11:00', '12:00', '13:00', '14:00',
  '15:00', '16:00', '17:00', '18:00'];

export default {
  name: 'BookingList',
  components: { Booking },
  props: ['bookings', 'day', 'info'],
  methods: {
    handleClick (e) {
      const hourHeight = e.target.offsetHeight / HOURS.length;
      const index = Math.floor(e.offsetY / hourHeight);
      const hour = HOURS[index];
      const date = this.day.date;
      if (hour) {
        this.$emit('click', {date, hour})
      } else {
        throw new Error('BookingList: hour not found.')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/color.scss';
@import 'src/values.scss';

.booking-list {
  display: flex;
  flex-direction: column;
  margin-bottom: $day-name-height;
  height: $full-day-height;
}

.day-info {
  background: white;
  flex: none;
  height: $day-name-height;
  border-bottom: 1px solid $table-border-color;
}

.booking-wrapper {
  flex: 1;
  position: relative;
}

.top55 {
  top: 5.5em;
  z-index: 99;
}

</style>



// WEBPACK FOOTER //
// src/components/BookingList.vue